export default "__VITE_ASSET__dr$KvFKm__"